<template>
  <el-dialog
      :title="'学生详情'"
      :visible.sync="subdialogDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="800px"
      center>
    <div class="volunteer-detail" v-if="stu">
      <div class="border-bottom padding-sm flex align-center justify-between">
        <div>
          <span class="name">{{ stu.stu_name }}</span>
          <span class="padding-left font-size-lg">性别：{{ stu.stu_sex === 1 ? '男' : '女' }}</span>
          <span class=" padding-left font-size-lg">年龄：{{ stu.stu_age }}</span>

          <br>
          <br>
          <span class=" font-size-lg">学校：{{ stu.school }}</span>
          <span class=" padding-left font-size-lg">班级：{{ stu.class_name }}</span>
        </div>
        <img :src="imgUrl + stu.img" alt="" width="200px">
      </div>
      <div class="flex align-center justify-around margin-tb">
        <el-button style="width: 200px" :type="type === 1?'primary':''" @click="type = 1">学历记录</el-button>
        <el-button style="width: 200px" :type="type === 2?'primary':''" @click="type = 2">实习记录</el-button>
        <el-button v-if="stu.files.length>0" style="width: 200px" :type="type === 3?'primary':''" @click="type = 3">简历附件</el-button>
      </div>
      <div v-if="type === 1">
        <div class="border-bottom padding-sm">
          <h2>学习课程:</h2>
          <div>
            <span class="margin-right" v-for="(item,index) in stu.classes" :key="index">{{ item }}</span>
          </div>
        </div>
        <div class="border-bottom padding-sm" v-if="stu.files.length>0">
          <h2>简历附件:</h2>
          <div v-for="(item,index) in stu.files" :key="index">
            <el-link :href="fileUrl + item.file_path" target="_blank">{{ item.file_name }}</el-link>
          </div>
        </div>
        <div class="border-bottom padding-sm">
          <h2 class="flex align-center justify-between">老师评语:

          </h2>
          <div v-for="(item,index) in stu.resumes" :key="index" class="margin-bottom-sm">
            <p>
              {{ item.content }}
            </p>
            <p class="flex justify-end" style="color: #999;">
              日期：{{ item.add_time }}
            </p>
          </div>
        </div>
      </div>
      <div v-if="type === 2">
        <div class="border-bottom padding-sm" v-for="item in stu.shixi" :key="item.id">
          <h2>实习机构： {{ item.sx_org_name }}</h2>

          <h2 v-if="item.finish_type === 2">实习时间：未报道</h2>
          <h2 v-else>
            实习时间：{{ item.start_date }} ~ {{ item.end_date }}
            <span v-if="item.finish_type === 3">(提前结束实习)</span>
          </h2>
          <div v-if="item.finish_type === 3">
            <p>提前结束实习原因：{{ item.remark }}</p>
          </div>
          <h2>实习岗位：</h2>
          <div>
            <p class="margin-right">{{ item.gw }}</p>
          </div>

          <h2 class="flex align-center justify-between">实习评语:
          </h2>
          <div class="margin-bottom-sm">
            <p>
              {{ item.ping }}
            </p>

          </div>
        </div>


      </div>
      <div v-if="type === 3">
        <div class="border-bottom padding-sm" >
          <h2>简历附件:</h2>
          <div v-for="(item,index) in stu.files" :key="index">
            <el-link :href="fileUrl + item.file_path" target="_blank">{{ item.file_name }}</el-link>
          </div>
        </div>
      </div>
    </div>


    <div class="flex align-center justify-around margin-top">
      <el-button type="primary" class="submit-btn" @click="resetForm">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {studentResume} from "@/api/fuse";
import {FILEURL, IMGURL} from "@/config";

export default {
  name: "StuDialog",
  props: {
    subdialogDialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    file: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      stu: null,
      imgUrl: IMGURL,
      type: 1,
      fileUrl: FILEURL
    }
  },
  created() {

  },
  methods: {
    async init() {
      let _info = await studentResume(this.setId, 'v', this.file)
      this.stu = _info.data
    },
    resetForm() {

      this.$emit('cancelDialog', false)
    },

  },
  watch: {
    setId() {
      if (this.setId && this.subdialogDialog) this.init()
    },
    subdialogDialog() {
      if (!this.subdialogDialog) {
        this.type = 1
      }
    }
  }
}
</script>

<style scoped lang="scss">
.volunteer-detail {
  width: 100%;
  border: 1px dashed #999;

  .border-bottom {
    border-bottom: 1px dashed #999;

    .name {
      font-size: 28px;
      font-weight: bold;
      color: #009688;
    }

    h2 {
      font-size: 18px;
      line-height: 42px;
      color: #009688;

      p {
        font-size: 14px;
        color: #666;
        line-height: 30px;
        text-align: right;
        font-weight: normal;
      }
    }

    div {
      line-height: 200%;
      font-size: 16px;

      p {
        text-indent: 32px;

        &.hals-color {
          color: #009688;
          text-indent: 0;
        }
      }
    }
  }
}
</style>